

































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Process from './Process';
import Solution from './Solution';
import SubProcess from './SubProcess';
import axios from 'axios';
import VueMarkdown from 'vue-markdown'

@Component({
    components: {
        VueMarkdown
    },
})
export default class Circulus extends Vue {
    isLoaded = false;

    items = Array<Process>();
    solutions = Array<Solution>();
    groupedSolutions = Array<Solution>();

    groupingOptions = new Array<any>();

    centerRadius = 40;
    innerR = 240;
    outerR = 180;
    gapBetweenCircles = 10;
    
    disableShowDisplay = setTimeout(function() { }, 750);

    // x and y must be equal
    innerCenter = { x: 450, y: 450 };
    outerCenter = { x: this.innerCenter.x, y: this.innerCenter.y };

    displayInfo = false;
    elementInfo = new Process({});

    beforeCreate() {
        axios.get("/api/reader/solutions").then(result => {
            if (result.data.status === 'success') {
                this.items = result.data.data.processes as Array<Process>;
                this.solutions = result.data.data.solutions as Array<Solution>;

                this.groupingOptions = this.getGroupingOptions();
                this.groupSolutionsBy(this.groupingOptions[0].groupName);
                this.elementInfo = this.items[0];
            } else if (result.data.status === 'error') {
                console.error(result.data.message);
            }

            this.$forceUpdate();
            this.isLoaded = true;
        }, error => { console.error(error); });
    }
    
    isLastSolution(i: number): boolean {
        return this.groupedSolutions.length < i + 2;
    }

    get someOuterIsExpanded() {
        return this.items.find(x => x.extendOuter);
    }

    get anySolutionHighlighted() {
        return this.solutions.find(x => x.highlight);
    }

    toggleSolutionDescription(solution: Solution) {
        solution.expandCollapsed = !solution.expandCollapsed;
        this.$forceUpdate();
    }

    async prepareDisableShowDisplay() {
        let self = this;
        clearTimeout(this.disableShowDisplay);
        
        this.disableShowDisplay = setTimeout(function() { 
                self.displayInfo = false; 
            }, 150);
    }
    
    async elementInfoShow(outerItem: SubProcess, innerItem: Process) {
        clearTimeout(this.disableShowDisplay);
        this.displayInfo = true;
        this.elementInfo = new Process({});
        this.elementInfo.processName = innerItem.processName;
        this.elementInfo.fill = innerItem.fill;
        await this.elementInfo.addSubProcess(outerItem);
    }

    innerTriggered(item: Process) {
        item.extendOuter = !item.extendOuter;
        this.unHighlightOuter();
        this.unHighlightAllSolutions();
        item.highlight = item.extendOuter;
    }

    groupSolutionsBy(groupingOption: string) {
        this.groupedSolutions = this.solutions.filter(x => x.serviceType === groupingOption);
    }

    unHighlightAllSolutions() {
        this.solutions.forEach(x => x.highlight = false);
        this.groupingOptions.forEach(x => x.highlightedSolutions = 0);
        this.items.forEach(x => x.subProcesses.forEach(y => y.solutions.forEach(z => z.highlight = false)));
    }

    highlightList(subProcess: SubProcess) {
        if (subProcess.highlight) {
            if (this.items.filter(x => x.subProcesses.filter(y => y.highlight).length !== 0).length <= 1) {
                this.unHighlightOuter();
                this.unHighlightAllSolutions();
                return;
            }
        }
        this.unHighlightOuter();
        this.unHighlightAllSolutions();

        this.solutions.forEach((x) => {
            subProcess.solutions.forEach((y) => {
                if (x.id === y.id)
                    x.highlight = true;
            });
        });

        let proc = this.items.find((x) => {
            const subPr = x.subProcesses.find(y => y === subProcess);

            return !(subPr === null || subPr === undefined);
        });
        if (proc === undefined || proc === null) return;

        proc.highlight = true;
        subProcess.highlight = true;
        subProcess.solutions.forEach(x => this.groupingOptions.find(y => y.groupName === x.serviceType).highlightedSolutions += 1);

        this.silenceUnHighLighted();
    }

    silenceUnHighLighted() {
        this.items.forEach(x => {
            x.subProcesses.forEach(y => {
                y.silenced = !y.highlight;
            })
        })
    }

    unSilenceAll() {
        this.items.forEach(x => {
            x.subProcesses.forEach(y => {
                y.silenced = false;
            })
        })
    }

    highlightCircle(solution: Solution) {
        if (solution.highlight) {
            this.unHighlightOuter();
            if (this.solutions.filter(x => x.highlight).length <= 1) {
                this.unHighlightAllSolutions();
                return;
            } else {
                this.unHighlightAllSolutions();
            }
        } else {
            this.unHighlightOuter();
            this.unHighlightAllSolutions();
        }

        this.items.forEach((x) => {
            x.subProcesses.forEach((y) => {
                y.solutions.forEach((z) => {
                    if (z.id === solution.id) {
                        y.highlight = true;
                        x.highlight = true;
                        x.extendOuter = true;
                    }
                });
            });
        });

        this.solutions.forEach((x) => {
            if (x.id === solution.id) x.highlight = true;
        });
        this.silenceUnHighLighted();
    }

    unHighlightAll() {
        this.items.forEach((x) => {
            x.extendOuter = false;
            x.highlight = false;
            x.subProcesses.forEach((y) => {
                y.highlight = false;
                y.solutions.forEach(z => {
                    z.highlight = false;
                });
            });
        });

        this.unHighlightAllSolutions();
        this.unSilenceAll();
    }

    hideOrShowAll() {
        if (this.items.find(x => x.extendOuter)) {
            this.unHighlightAll();
        } else {
            this.items.forEach((x) => {
                x.extendOuter = true;
                x.highlight = true;
            });
        }
    }

    unHighlightOuter() {
        this.items.forEach((x) => {
            x.subProcesses.forEach((y) => {
                y.highlight = false;
                y.solutions.forEach(z => z.highlight = false);
            });
        });
        this.unSilenceAll();
    }

    formatTextWrap(text: string, maxLineLength: number) {
        const words = text.replace(/[\r\n]+/g, ' ').split(' ');
        let lineLength = 0;
        const res = words.reduce((result, word) => {
            if (lineLength + word.length >= maxLineLength) {
                lineLength = word.length;
                return `${result}\n${word}`; // don't add spaces upfront
            }
            lineLength += word.length + (result ? 1 : 0);
            return result ? `${result} ${word}` : `${word}`; // add space only when needed
        }, '');

        return res.split('\n');
    }

    getScale(inner: number) {
        const innerItem = this.items[inner];
        let currentOuterFromZeroCount = 0;
        let totalOuterCount = 0;
        this.items.forEach((x, index) => {
            if (index === inner) currentOuterFromZeroCount = totalOuterCount + (x.subProcesses.length / 2);
            totalOuterCount += x.subProcesses.length;
        });

        if (innerItem === null || innerItem === undefined) return;

        const innerAngle = 360 / totalOuterCount * currentOuterFromZeroCount;

        return innerAngle >= 90 && innerAngle < 270 ? '-1, -1' : '1, 1';
    }

    getRotationOuter(): string {
        let totalOuterCount = 0;
        this.items.forEach((x) => {
            totalOuterCount += x.subProcesses.length;
        });
        const rotationDegree = (360 / totalOuterCount) / 2;
        return `-${rotationDegree}, ${this.innerCenter.x}, ${this.innerCenter.y}`;
    }

    getRotationInner(innerId: number): string {
        let totalOuterCount = 0;
        this.items.forEach((x) => {
            totalOuterCount += x.subProcesses.length;
        });

        let innerItem = this.items.find(x => x.id === innerId);
        if (innerItem === null || innerItem === undefined) return `0, ${this.innerCenter.x}, ${this.innerCenter.y}`;

        const rotationDegree = (360 / totalOuterCount * innerItem.subProcesses.length) / 2;

        return `-${rotationDegree}, ${this.innerCenter.x}, ${this.innerCenter.y}`
    }

    getTranslation(innerId: number, outer: number, isInner: boolean) {
        if (isInner) {
            if (this.getScale(--innerId) === '-1, -1') {
                return `${590 - (480 - this.innerCenter.x)},
            ${507 - (480 - this.innerCenter.y)}`;
            } else {
                return `${550 - (480 - this.innerCenter.x)},
            ${453 - (480 - this.innerCenter.y)}`;
            }
        }
        ++outer;
        if (this.getScale(--innerId) === '-1, -1') {
            return `${-300 + this.gapBetweenCircles + Math.abs(this.innerR) + (this.outerCenter.x) + (this.outerR - 60) / 2},
          ${this.outerCenter.y - 323}`;
        } else {
            return `${-340 + this.gapBetweenCircles + Math.abs(this.innerR) + (this.outerCenter.x) + (this.outerR - 60) / 2},
          ${this.outerCenter.y - 376}`;
        }
    }

    getInnerPoint(innerId: number): string {
        const innerItem = this.items.find(x => x.id === innerId);
        if (innerItem === null || innerItem === undefined)
            return '';
        let outerCount = innerItem.subProcesses.length;
        let totalOuterCount = 0;
        this.items.forEach((x) => {
            totalOuterCount += x.subProcesses.length;
        });

        let angle = 360 / totalOuterCount * outerCount;
        const isAcute = angle <= 90;

        // for top point

        let xTop;
        let yTop;

        if (isAcute) {
            angle = angle * Math.PI / 180;
            xTop = Math.cos(angle) * this.innerR;
            yTop = Math.sqrt(Math.pow(this.innerR, 2) - Math.pow(xTop, 2));
            xTop += this.innerCenter.x;
            yTop = Math.abs(this.innerCenter.y - yTop);
        } else {
            angle -= 90;
            angle = angle * Math.PI / 180;
            yTop = Math.cos(angle) * this.innerR;
            xTop = Math.sqrt(Math.pow(this.innerR, 2) - Math.pow(yTop, 2));
            yTop = Math.abs(this.innerCenter.y - yTop);
            xTop = this.innerCenter.x - xTop;
        }

        // for bottom point

        let xBot = 0;
        let yBot = 0;

        if (isAcute) {
            xBot = Math.cos(angle) * this.centerRadius;
            yBot = Math.sqrt(Math.pow(this.centerRadius, 2) - Math.pow(xBot, 2));
            xBot += this.innerCenter.x - xTop;
            yBot = this.innerCenter.y - yTop - yBot;
        } else {
            yBot = Math.cos(angle) * (this.innerR - this.centerRadius);
            xBot = Math.sqrt(Math.pow((this.innerR - this.centerRadius), 2) - Math.pow(yBot, 2));
        }

        return `M${this.innerCenter.x + this.centerRadius},${this.innerCenter.y}
        l${this.innerR - this.centerRadius},0
        A${this.innerR},${this.innerR}
        0
        0,0
        ${xTop},${yTop}
        l${xBot},${yBot}
        A${this.centerRadius},${this.centerRadius}
        0
        0,1
        ${this.innerCenter.x + this.centerRadius},${this.innerCenter.y}`;
    }

    getInnerMatrix(innerId: number): string {
        let currentOuterFromZeroCount = 0;
        let totalOuterCount = 0;
        this.items.forEach((x) => {
            if (x.id === innerId) currentOuterFromZeroCount = totalOuterCount;
            totalOuterCount += x.subProcesses.length;
        });

        const angleInRadians = (360 / totalOuterCount * currentOuterFromZeroCount) * (Math.PI / 180);
        const yShorter = this.innerCenter.x > this.innerCenter.y && this.innerCenter.x !== this.innerCenter.y;
        const xShorter = this.innerCenter.x < this.innerCenter.y && this.innerCenter.x !== this.innerCenter.y;
        const diff = Math.abs(this.innerCenter.x - this.innerCenter.y);

        const translationMatrix = [
            [1, 0, innerId == 1 ? 0
                : (this.innerCenter.x
                    - (Math.cos(angleInRadians) + Math.sin(angleInRadians))
                    * (xShorter ? this.innerCenter.x + diff : this.innerCenter.x))],

            [0, 1, innerId == 1 ? 0
                : (this.innerCenter.y
                    + (Math.sin(angleInRadians) - Math.cos(angleInRadians))
                    * (yShorter ? this.innerCenter.y + diff : this.innerCenter.y))],
            [0, 0, 1],
        ];
        const rotationMatrix = [
            [Math.cos(angleInRadians), Math.sin(angleInRadians), 0],
            [-Math.sin(angleInRadians), Math.cos(angleInRadians), 0],
            [0, 0, 1],
        ];

        const finalMatrix = this.fixMatrix(this.multiplyMatrices(translationMatrix, rotationMatrix));
        return `matrix(${finalMatrix[0][0]}, ${finalMatrix[1][0]}, ${finalMatrix[0][1]}, ${finalMatrix[1][1]}, ${finalMatrix[0][2]}, ${finalMatrix[1][2]})`;
    }

    getOuterPoint(subProcess: SubProcess): string {
        let subs = 0;

        this.items.forEach((x) => {
            subs += x.subProcesses.length;
        });

        let angle = 360 / subs;
        const isAcute = angle <= 90;
        const isObtuse = angle > 90 && angle <= 180;

        let x;
        let y;

        const xTop = this.innerR + this.gapBetweenCircles + subProcess.additionalLength;
        const xBot = this.innerR + this.gapBetweenCircles;

        // top corner end

        if (isAcute) {
            angle = angle * Math.PI / 180;
            x = Math.cos(angle) * (xTop + this.outerR); // full length of R
            y = Math.sqrt(Math.pow((xTop + this.outerR), 2) - Math.pow(x, 2));
            x += (this.outerCenter.x);
            y = this.outerCenter.y - y;
        } else {
            angle -= 90;
            angle = angle * Math.PI / 180;
            y = Math.cos(angle) * (xTop + this.outerR);
            x = Math.sqrt(Math.pow((xTop + this.outerR), 2) - Math.pow(y, 2));
            y = (this.outerCenter.y + this.outerR) - y;
        }
        const outerXt = x;
        const outerYt = y;

        // bottom corner end

        if (isAcute) {
            x = Math.cos(angle) * xBot;
            y = Math.sqrt(Math.pow(xBot, 2) - Math.pow(x, 2));
        } else {
            y = Math.cos(angle) * xBot;
            x = Math.sqrt(Math.pow(xBot, 2) - Math.pow(y, 2));
        }

        const outerXb = (this.outerCenter.x - outerXt) + x;
        const outerYb = (this.outerCenter.y - outerYt) - y;

        return `M${this.outerCenter.x + xBot},${this.outerCenter.y}
        l${this.outerR + subProcess.additionalLength},0
        A${(this.outerR + xTop)},${this.outerR + xTop}
        0
        0,0
        ${outerXt},${outerYt}
        l${outerXb},${outerYb}
        A${xBot},${xBot}
        0
        0,1
        ${this.outerCenter.x + xBot},${this.outerCenter.y}`;
    }

    getOuterMatrix(number: number, outer: number): string {
        let count = 0;
        let curr = 0;

        this.items.forEach((x) => {
            if (x.id === number) {
                curr = count + outer;
            }

            count += x.subProcesses.length;
        });
        --number;


        const innerAngleInDegrees = 360 / count;
        const angleInDegrees = (innerAngleInDegrees * curr);
        const angleInRadians = angleInDegrees * (Math.PI / 180);

        const translationMatrix = [
            [1, 0, number == 0 && outer == 0 ? 0 : (this.outerCenter.x - (Math.cos(angleInRadians) + Math.sin(angleInRadians)) * this.outerCenter.x)],
            [0, 1, number == 0 && outer == 0 ? 0 : ((Math.sin(angleInRadians) - Math.cos(angleInRadians)) * this.outerCenter.y + this.outerCenter.y)],
            [0, 0, 1],
        ];
        const rotationMatrix = [
            [Math.cos(angleInRadians), Math.sin(angleInRadians), 0],
            [-Math.sin(angleInRadians), Math.cos(angleInRadians), 0],
            [0, 0, 1],
        ];

        const finalMatrix = this.fixMatrix(this.multiplyMatrices(translationMatrix, rotationMatrix));
        return `matrix(${finalMatrix[0][0]}, ${finalMatrix[1][0]}, ${finalMatrix[0][1]}, ${finalMatrix[1][1]}, ${finalMatrix[0][2]}, ${finalMatrix[1][2]})`;
    }

    fixMatrix(matrix: any) { // concidering it's a 2d matrix
        matrix[0][0] = this.isCloseToZero(matrix[0][0]) ? 0 : matrix[0][0];
        matrix[1][0] = this.isCloseToZero(matrix[1][0]) ? 0 : matrix[1][0];
        matrix[0][1] = this.isCloseToZero(matrix[0][1]) ? 0 : matrix[0][1];
        matrix[1][1] = this.isCloseToZero(matrix[1][1]) ? 0 : matrix[1][1];
        matrix[0][2] = this.isCloseToZero(matrix[0][2]) ? 0 : matrix[0][2];
        matrix[1][2] = this.isCloseToZero(matrix[1][2]) ? 0 : matrix[1][2];

        return matrix;
    }

    isCloseToZero(val: number) {
        return (val < 1e-10 && val > 1e-20) || (val > -1e-10 && val < -1e-20);
    }

    multiplyMatrices(matrixA: any, matrixB: any) {
        const newMatrix = new Array(matrixA.length);
        for (let r = 0; r < matrixA.length; ++r) {
            newMatrix[r] = new Array(matrixB[0].length);
            for (let c = 0; c < matrixB[0].length; ++c) {
                newMatrix[r][c] = 0;
                for (let i = 0; i < matrixA[0].length; ++i)
                    newMatrix[r][c] += matrixA[r][i] * matrixB[i][c];                    
            }
        }

        return newMatrix;
    }

    getGroupingOptions(): any[] {
        let options: any[] = [];
        this.solutions.forEach(x => {
            if (options) {
                if (options.find(y => y.groupName === x.serviceType)) {
                    options.find(y => y.groupName === x.serviceType).totalSolutions += 1;
                } else {
                    options.push({ groupName: x.serviceType, totalSolutions: 1, highlightedSolutions: 0 });
                }
            } else {
                options = [];
                options.push({ groupName: x.serviceType, totalSolutions: 1, highlightedSolutions: 0 });
            }
        });
        return options;
    }
}
